import React, { Fragment } from "react";
import ListGroup from 'react-bootstrap/ListGroup';


/**
 * This is the main side Card menu. When items are clicked it resets the window to the top.
 */
const FamilyMenu = (props) => {
    const { selectFamily, familyMenuItems, setActiveMenuItem } = props;
    return (
    <div className="subject__div fixed-families">
      <ListGroup>
        {familyMenuItems.map(menuItem => {
          const { icon, family, familyID, active, tab } = menuItem;
          const menuActive = active ? "family-menu--active" : "";
          return familyID === 17 ? (
            ""
          ) : (
            <Fragment key={familyID}>
              <ListGroup.Item
                
                onClick={() => {
                  selectFamily(familyID);
                  setActiveMenuItem(familyID);
                  window.scroll(0, 0);
                }}
                className={`${menuActive} listgroup__item`} 
                tabIndex={tab}
              >
                <i className="family__icon">{icon}</i>
                <p className="subject__name" primary={family}>{family}</p>
              </ListGroup.Item>
            </Fragment>
          );
        })}
      </ListGroup>
    </div>
  );
}

export default FamilyMenu;
